import './banner.css';

export const Banner = () => {
  return (
    <div className="banner">
      If you're seeing this we're still in beta.&nbsp; (If you have feedback, please join our <a className="underline" href="https://t.me/+N3ewm5-2IvxkMjYx">Telegram beta chat</a>)!
    </div>
  )
}
